import { render } from "./MailsPage.vue?vue&type=template&id=c9180484"
import script from "./MailsPage.vue?vue&type=script&lang=js"
export * from "./MailsPage.vue?vue&type=script&lang=js"

import "./MailsPage.vue?vue&type=style&index=0&id=c9180484&lang=css"

import exportComponent from "/home/user/ade-home/chantiervocal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__